import * as Features from '../../../../../../../shared/Features';
import { AuthenticatedUser } from '../../../../../../../shared/types';
import { CommentType } from '../../../Entities';
import { ImageProcessingComments } from '../queries/use-query-image-processing-comments';

export type CommentPanelDefinition = {
    type: number;
    field: keyof ImageProcessingComments;
    titleKey: string;
    canEdit: boolean;
};

export function getVisibleCommentPanels(user: AuthenticatedUser): CommentPanelDefinition[] {
    let panels: CommentPanelDefinition[] = [];

    if (
        Features.hasAnyFeature(
            [Features.ViewImageEditorComments, Features.ViewInformationToPhotographer],
            user
        )
    ) {
        panels.push({
            type: CommentType.FROM_IMAGE_EDITOR,
            field: 'fromEditorComment',
            titleKey: 'image-processing/page/comments/header/from-image-editor',
            canEdit: Features.hasFeature(Features.UpdateCommentFromEditor, user)
        });
    }

    if (
        Features.hasAnyFeature(
            [Features.ViewInformationToImageEditor, Features.UpdateCommentFromPhotographer],
            user
        )
    ) {
        panels.push({
            type: CommentType.FROM_PHOTOGRAPHER_TO_EDITOR,
            field: 'fromPhotographerToEditorComment',
            titleKey: 'image-processing/page/comments/header/from-photographer-to-editor',
            canEdit: Features.hasFeature(Features.UpdateCommentFromPhotographer, user)
        });
    }

    if (Features.hasFeature(Features.ViewInformationToImageEditor, user)) {
        let canEditNotesToEditor = Features.hasFeature(Features.UpdateCommentToEditor, user);

        panels.push({
            type: CommentType.TO_IMAGE_EDITOR_FROM_CHAIN,
            field: 'toEditorFromChainComment',
            titleKey: 'image-processing/page/comments/header/to-image-editor-from-chain',
            canEdit: canEditNotesToEditor
        });
        panels.push({
            type: CommentType.TO_IMAGE_EDITOR_FROM_FIRM,
            field: 'toEditorFromFirmComment',
            titleKey: 'image-processing/page/comments/header/to-image-editor-from-firm',
            canEdit: canEditNotesToEditor
        });
    }

    return panels;
}
